module.exports = __webpack_public_path__ + "static/Raleway-SemiBoldItalic-88c09e32b3cb33a9996fed9107272079.woff2";